<!-- P10S3 Component - Section 3 - Allocation and Apportionment Methods for Deductions -->
<div class="f1065-k2-container">

  <!-- INITIAL LOADING STATE - shown when waiting for filter selection -->
  @if (loadingData) {
<div class="gg-loader">
    <div class="gg-loader-text">
      <img src="assets/img/arrow-filter-sm.png" alt="">
    </div>
  </div>
}

  <!-- MAIN CONTENT - shown after initialization -->
  @if (!loadingData) {
<div>
    
    <!-- FORM LOADER - shown while fetching data after filter selection -->
    @if (showLoader) {
<div class="form-loader">
      <div class="css-spinner"></div>
    </div>
}

    <!-- FORM CONTENT -->
    @if (!showLoader) {
<div>
    <!-- Section Header -->
    <p class="h5 section-header">
      <b>{{ sectionHeader }}</b>
    </p>

    <div class="table-responsive">
      <!-- SEC 1 (UI_S1) -->
      <table class="table table-striped blue tbl-cus-width">
        <thead>
          <tr align="center">
            @if (showErrCol && isUIErrorSec.includes('UI_S1')) {
<th style="width: 200px;">Error</th>
}
            <th class="hd-sno" style="text-align: center">Line</th>
            <th style="text-align: center">Description</th>
            @for (cols of getColHeadersForSection('UI_S1'); track $index) {
<th
                style="width:122px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }}
              @if (cols.IS_MANDATORY === 'Y') {
<span>*</span>
}
              @if (cols.IS_PREF_MANDATORY === 'Y') {
<span>+</span>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of getRowsForSection('UI_S1'); track trackByRow($index, x)) {
<tr>
            <!-- Error Column -->
            @if (showErrCol && isUIErrorSec.includes(x.LINE_SEC || '')) {
<td class="err-col">
              <div [ngClass]="x.ERR_MSG && x.ERR_MSG.length > 0 ? 'err-cell-yes' : 'err-cell-no'"
                   [innerHTML]="x.ERR_MSG"></div>
            </td>
}

            <!-- Line Number -->
            <td style="font-weight:bold; white-space: nowrap; padding-right: 5px; text-align: right;">
              @if (x.SNO === 0 && x.IS_LINE_MULTI === 'Y') {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-plus-circle color-green"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              @if (x.SNO > 0) {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-minus-circle color-red"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              @if (x.SNO === 0) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description -->
            <td><p>{{ x.SNO === 0 ? x.LINE_DESC : '' }}</p></td>

            <!-- Data Cells -->
            @for (amts of x.items; track trackByCol($index, amts)) {
<td
                style="height: 30px; width:122px; text-align: right;">
              <!-- NUMERIC -->
              @if (amts.UI_COMP === 'NUMERIC') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     onlyIntegersWithLength
                     style="text-align: right;"
                     (ngModelChange)="calcTotalsCol(x.items)">
}
              
              <!-- TEXT -->
              @if (amts.UI_COMP === 'TEXT') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [maxlength]="amts.MAX_LENGTH || 999"
                     style="text-align: right;">
}
            </td>
}
          </tr>
}
        </tbody>
      </table>

      <!-- SEC 2 (UI_S2) -->
      <table class="table table-striped blue tbl-cus-width">
        <thead>
          <tr align="center">
            @if (showErrCol && isUIErrorSec.includes('UI_S2')) {
<th style="width: 200px;">Error</th>
}
            <th class="hd-sno" style="text-align: center">Line</th>
            <th style="text-align: center">Description</th>
            @for (cols of getColHeadersForSection('UI_S2'); track $index) {
<th
                style="width:122px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }}
              @if (cols.IS_MANDATORY === 'Y') {
<span>*</span>
}
              @if (cols.IS_PREF_MANDATORY === 'Y') {
<span>+</span>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of getRowsForSection('UI_S2'); track trackByRow($index, x)) {
<tr>
            <!-- Error Column -->
            @if (showErrCol && isUIErrorSec.includes(x.LINE_SEC || '')) {
<td class="err-col">
              <div [ngClass]="x.ERR_MSG && x.ERR_MSG.length > 0 ? 'err-cell-yes' : 'err-cell-no'"
                   [innerHTML]="x.ERR_MSG"></div>
            </td>
}

            <!-- Line Number -->
            <td style="font-weight:bold; white-space: nowrap; padding-right: 5px; text-align: right;">
              @if (x.SNO === 0 && x.IS_LINE_MULTI === 'Y') {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-plus-circle color-green"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              @if (x.SNO > 0) {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-minus-circle color-red"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              @if (x.SNO === 0) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description -->
            <td><p>{{ x.SNO === 0 ? x.LINE_DESC : '' }}</p></td>

            <!-- Data Cells -->
            @for (amts of x.items; track trackByCol($index, amts)) {
<td
                style="height: 30px; width:122px; text-align: right;">
              <!-- NUMERIC -->
              @if (amts.UI_COMP === 'NUMERIC') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     onlyIntegersWithLength
                     style="text-align: right;"
                     (ngModelChange)="calcTotalsCol(x.items)">
}
              
              <!-- TEXT -->
              @if (amts.UI_COMP === 'TEXT') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [maxlength]="amts.MAX_LENGTH || 999"
                     style="text-align: right;">
}

              <!-- DROP_DOWN -->
              @if (amts.UI_COMP === 'DROP_DOWN') {
<select
                      class="form-control min-ele-wid k2-select"
                      [ngClass]="{
                        'custom-error': amts.IS_ERROR === 'Y',
                        'custom-textbox': amts.IS_ENABLED === 'Y'
                      }"
                      [(ngModel)]="amts.CELL_VALUE"
                      [disabled]="amts.IS_ENABLED === 'N'"
                      style="height: 30px; width: 90%;">
                <option value="">--Select--</option>
                @for (opt of amts.actionData; track $index) {
<option [value]="opt.VALUE">{{ opt.LABEL }}</option>
}
              </select>
}
            </td>
}
          </tr>
}
        </tbody>
      </table>

      <!-- SEC 3 (UI_S3) -->
      <table class="table table-striped blue tbl-cus-width">
        <thead>
          <tr align="center">
            <th class="hd-sno" style="text-align: center">Line</th>
            <th style="text-align: center">Description</th>
            @for (cols of getColHeadersForSection('UI_S3'); track $index) {
<th
                style="width:122px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }}
              @if (cols.IS_MANDATORY === 'Y') {
<span>*</span>
}
              @if (cols.IS_PREF_MANDATORY === 'Y') {
<span>+</span>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of getRowsForSection('UI_S3'); track trackByRow($index, x)) {
<tr>
            <!-- Line Number -->
            <td style="font-weight:bold; white-space: nowrap; padding-right: 5px; text-align: right;">
              @if (x.SNO === 0 && x.IS_LINE_MULTI === 'Y') {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-plus-circle color-green"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              @if (x.SNO > 0) {
<i
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 class="fa fa-minus-circle color-red"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              @if (x.SNO === 0) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description -->
            <td><p>{{ x.SNO === 0 ? x.LINE_DESC : '' }}</p></td>

            <!-- Data Cells -->
            @for (amts of x.items; track trackByCol($index, amts)) {
<td
                style="height: 30px; width:122px; text-align: right;">
              <!-- NUMERIC -->
              @if (amts.UI_COMP === 'NUMERIC') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     onlyIntegersWithLength
                     style="text-align: right;"
                     (ngModelChange)="calcTotalsCol(x.items)">
}
              
              <!-- TEXT -->
              @if (amts.UI_COMP === 'TEXT') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [maxlength]="amts.MAX_LENGTH || 999"
                     style="text-align: right;">
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- Buttons -->
    @if (isAdmin) {
<div class="k2-buttons-container">
      <button class="save-button" type="button" (click)="save()" [disabled]="isSaveClicked">Save</button>
      <button class="reset-button" type="button" (click)="reset()" [disabled]="!isAdmin">Reset</button>
    </div>
}
    </div>
} <!-- closes content -->
  </div>
} <!-- closes !loadingData -->
</div> <!-- closes f1065-k2-container -->

<!-- Confirmation Modal -->
@if (showConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onSaveConfirm()"
    (cancelled)="onSaveCancel()"
    (closed)="onSaveCancel()">
  </gtw-confirmation-modal>
</div>
}
